import { generateQueryString } from '../../common/base/report/report-util';

export const queryStringCalcForReports = ({
  criteria,
  token,
  isSaiMonthly,
  isReportPrint,
}) => {
  const params = [];
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (isSaiMonthly && criteria.monthyear.month) {
    params.push(`month=${criteria.monthyear.month}`);
  }

  if (isReportPrint) {
    params.push(`isReport=${isReportPrint}`);
  }

  if (isSaiMonthly && criteria.monthyear.year) {
    params.push(`year=${criteria.monthyear.year}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};
export const queryStringCalcForReconReports = ({
  criteria,
  singleBank,
  token,
}) => {
  const params = [];
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (criteria.asOfDate) {
    params.push(`date=${criteria.asOfDate}`);
  }
  if (singleBank) {
    params.push(`bank=${singleBank}`);
  }
  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};
export const queryStringCalcForCollateralReports = ({
  criteria,
  token,
}) => {
  const params = [];
  if (criteria.fiscalYear) {
    params.push(`fiscalYear=${criteria.fiscalYear}`);
  }

  if (token) {
    params.push(`token=${token}`);
  }
  return generateQueryString(params);
};

export default {
  queryStringCalcForReports,
  queryStringCalcForReconReports,
  queryStringCalcForCollateralReports,
};
